import React from 'react';

export default () => <svg width="100px" height="100px"
    viewBox="0 0 100 100" >
    <polyline points="11.71,89.06 24.87,41.42 31.69,53.28 49.4,10.94 67.12,40.74 71.88,34.31 88.3,89.06 " />
    <polygon points="24.87,41.42 11.71,89.06 88.3,89.06 71.88,34.31 67.12,40.74 49.4,10.94 31.69,53.28 " />

</svg>